<script setup>
import DocSection from '@/components/Docs/Section.vue'
import CodeBlock from '@/components/Docs/CodeBlock.vue'
import JsonBlock from '@/components/Docs/JsonBlock.vue'
import Jumbo from '@/components/Docs/Jumbo.vue'
  
</script>

<template>
  <div class="row">
    <doc-section title="Response types">
      <template v-slot:left>
        Using the API you will generally encounter 4 different types of responses. These are easily distinguished by their HTTP status codes. 
<br><br>

All successful requests to the API will return a JSON response with an associated 200 HTTP status code. The response will always have a status field and a data field, and depending on the endpoint additional meta fields. The data field contains the desired information.
<br><br>

If the input provided to the endpoint is of a wrong format or invalid, a “400: Bad request” response will be returned, with no additional information.

<br><br>
If an authenticated endpoint is accessed with an invalid or inactive API key, a “401: Not Authorized” response will be returned, with no additional information.
<br><br>

Should your account have exceeded your API usage quotas, a “429: Too many requests” will be returned.

      </template>

      <template v-slot:right>
        <json-block title="General Response format" :statuscode="200">
          {
            "status": "success | failed",
            "data": {} 
          } 
        </json-block>
        <json-block :raw="true" title="Invalid input" :statuscode="400">
          Bad Request
        </json-block>
        <json-block :raw="true" title="Invalid API key" :statuscode="401">
         Not Authorized 
        </json-block>
        <json-block :raw="true" title="Usage quota exceeded" :statuscode="429">
          Too many requests
        </json-block>
        
      </template>
    </doc-section>

  </div>
</template>


<style scoped>
</style>
